import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import {
  Box,
  Chip,
  Table,
  Paper,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Typography,
  TableContainer,
} from "@mui/material";

import Title from "../../../common/Title";
import ApiLogHistory from "../../../common/ApiLogHistory";

import useAxios from "../../../../hooks/useAxios";
import { __getIMSILog } from "../../../../api/sim";
import { getChipColor, OPERATIONS } from "../../../../constants/value";

const IMSIHistory = ({ operation }) => {
  const [imsiHistory, setIMSIHistory] = useState([]);
  const { imsi_id } = useParams();

  const [response, call, loading] = useAxios({
    ...__getIMSILog(imsi_id, operation),
  });

  useEffect(() => {
    if (response && response.status) {
      setIMSIHistory(response.data);
    }
  }, [response]);

  useEffect(() => {
    call();
  }, []);

  return loading ? (
    <Title content="Please wait..." variant="subtitle2" gutterBottom />
  ) : (
    <>
      <Box mb={2} pt={2}>
        <Typography variant="h5" align="left">
          IMSI {operation === OPERATIONS.imsi_create ? "create" : "delete"} Log
        </Typography>
      </Box>

      {response && imsiHistory.data ? (
        <>
          <Box
            sx={{ width: "100%", mb: 5 }}
            display="flex"
            alignItems="center"
            flexDirection="column"
          >
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">IMSI</TableCell>
                    <TableCell align="left">Batch ID</TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="left">Last Updated</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="left">{imsiHistory.data.imsi}</TableCell>
                    <TableCell align="left">
                      <Link
                        underline="none"
                        to={`/sparq/imsi/${operation}/batch/${imsiHistory.data.batch_id}`}
                      >
                        {imsiHistory.data.batch_id}
                      </Link>
                    </TableCell>
                    <TableCell align="left">
                      <Chip
                        label={imsiHistory.data.status}
                        size="small"
                        color={getChipColor(imsiHistory.data.status)}
                      />
                    </TableCell>
                    <TableCell align="left">
                      {imsiHistory.data.last_updated &&
                        `${format(
                          new Date(imsiHistory.data.last_updated),
                          "MMMM d, y hh:mm a"
                        )}`}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <ApiLogHistory data={imsiHistory.history.data} />
        </>
      ) : (
        <Box mb={2} pt={2}>
          <Typography variant="h5" align="left">
            No Data
          </Typography>
        </Box>
      )}
    </>
  );
};

export default IMSIHistory;
